import { useQuery } from '@tanstack/react-query';
import { default as productsService } from "@/components/Contractation/services/products";
import { 
  StepInstallationFormData, 
  StepPersonFormData,
} from '../../types/stepsFormData';
import { Powers, StepElecContractFormData } from '../../components/FormContract/types/FormContract';
import { allPowersFull } from '../../components/FormContract/utils/FormContract';

interface IUseProductsProps {
  power: Powers; 
  selfcons: StepElecContractFormData["selfcons"]["enabled"];
  accessTariff: StepElecContractFormData["accessTariff"]["id"];
  promotionalCode: StepElecContractFormData["promotionalCode"];
  cups: StepInstallationFormData["cups"];
  lang: StepPersonFormData["commsLanguage"];
}

export const useProducts = ({
  power,
  selfcons,
  accessTariff,
  cups,
  promotionalCode,
  lang
}: IUseProductsProps) => {
  const isReady = 
    allPowersFull(power)
    && accessTariff >= 0
    && cups !== '';
  
  const maxPower = Math.max(...power.periods);

  return useQuery({
    queryKey: ['products', power, selfcons, accessTariff, cups, promotionalCode, lang],
    queryFn: () => productsService.fetchAvailableProducts({
      power: maxPower,
      selfcons,
      accessTariff,
      cups,
      promotionalCode,
    }),
    enabled: isReady,
    staleTime: 1000 * 60 * 30 // 5 minutes (cached data remains fresh for this duration)
  })
}

export const useGasProducts = ({
  accessTariff,
  cups,
  lang
}: Pick<IUseProductsProps, "accessTariff" | "cups" | "lang">) => {
  const isReady = accessTariff > 0 && cups !== '';

  return useQuery({
    queryKey: ['gasProducts', accessTariff, cups, lang],
    queryFn: () => productsService.fetchAvailableGasProducts({
      accessTariff,
      cups,
    }),
    enabled: isReady,
    staleTime: 1000 * 60 * 30 // 5 minutes (cached data remains fresh for this duration)
  })
}